export const capitalize = (str: string): string => {
  return str && str.charAt(0).toUpperCase() + str.slice(1)
}

export const capitalizeEachWord = (str: string): string => {
  return str.split(' ').map(capitalize).join(' ')
}

export const replaceSpacesWithDashes = (str: string): string => str.replace(/\s+/g, '-').toLowerCase()

/**
 * Puts an underscore before every capital letter, except the first one
 *
 * Example:
 *    PlansPageLink -> Plans_Page_Link
 */
export const capitalizedToUnderscores = (name: string): string => name.replace(/(.)([A-Z])/g, '$1_$2')

export const calculateWordCount = (text: string): number => {
  const words = text.replace(/[',.]/gi, '').replace(/[\d]/gi, ' ').trim().replace(/\s+/gi, ' ')
  return words === '' ? 0 : words.split(' ').length
}

export const trimUserText = (userText: string, charCount: number) => userText.trim().slice(0, charCount)

/**
 * Normalize a string by trimming and converting to lowercase
 */
export const normalizeString = (value: string): string => value.trim().toLowerCase()
